/* eslint-disable */
import Swiper, { Pagination, Navigation } from "swiper";
Swiper.use([Navigation, Pagination]);

export default {
    init() {
        const swiper = new Swiper('.stories__container', {
            slidesPerView: 1,
            speed: 700,
            loop: true,
            loopAdditionalSlides: 1,
            autoHeight: true,
            navigation: {
                nextEl: '.stories__next',
                prevEl: '.stories__prev',
              },
            pagination: {
                el: '.stories__pagination',
                clickable: true
              },
            breakpoints: {
                768: {
                    autoHeight: false,
                },
            },
        });
    }
}